// Accounts are no longer created or invited from a page of their own: people join an
// organisation by invitation (Settings -> Organisation invitations) and a workspace by being
// added from the organisation (Settings -> Members).
const CreateUserPAge = () => (
  <div />
);
export default CreateUserPAge;
